import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';

import { AttentionModalComponent } from '../attention-modal/attention-modal.component';

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RktButtonDirective, AttentionModalComponent],
})
export class SuccessModalComponent {
  actionName!: string;

  type!: 'Counterparty' | 'TeamMember' | 'FinancialAccount' | 'Transaction' | 'Customer';

  customTitle = '';

  get typeText() {
    switch (this.type) {
      case 'TeamMember':
        return 'Team Member';
      case 'Counterparty':
        return 'Counterparty Account';
      case 'FinancialAccount':
        return 'Financial Account';
      case 'Transaction':
        return 'Transaction';
      case 'Customer':
        return 'Customer Account';
      default:
        return this.type;
    }
  }

  constructor(public activeModal: ActiveModal) {}
}
